























































































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import Combobox from '../../core/components/Combobox.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import DownloadFileExtension from '../../core/components/DownloadFileExtension.vue';
import ModalCheckboxList from '../../core/components/ModalCheckboxList.vue';
import ModalInsuranceHarvest from '../../insurance/components/ModalInsuranceHarvest.vue';
import ListFilters from '../../insurance/components/ListFilters.vue';
import { MultipleSelect } from '../../core/components';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import FilterByDateRange from '../../core/components/FilterByDateRange.vue';
// import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import {
    goToUrl,
    getIdsFromList,
    formatDate,
    getCurrentTimestamp,
    booleanFormatter,
    nestedFilter,
    isNullOrEmpty,
    downloadArrayBuffer,
    PRIVILEGE_KEYS
} from '../../core/utils/';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { InsuranceServices } from '../api/InsuranceServices';
import Axios, { CancelTokenSource } from 'axios';
import { getUrlRanchDetail, getUrlRanchSowingDetail, sowingExportDepurationsOptions } from '../utils';
import { dateTypes, defaultSelectedOption } from '../../core/models';
import { InsuranceFilters, sowingDepurationExport, SowingRanchListFilters } from '../api/models';
import { filterByStartDate, filterByEndDate } from '../filters'
import { areaClasificada, areaSinClasificar, areaTotal, areaTotalCerrada, areaTotalResiembra, areaTrabajada } from '../indicators'
import { sortTypes } from '../../../features/core/models/Table';
import { sowingRanchsProperties } from '../api/sowingModels';
import { getValueAndUnit, getValueParsedByType, unitsValuesChoices, unitValues } from '../../../features/core/api';
import { farmingTypesDict } from '../helpers';

@Component({
    components: {
        Summary,
        Combobox,
        SimpleTable,
        ModalInsuranceHarvest,
        Button,
        Input,
        DownloadFileExtension,
        ListFilters,
        MultipleSelect,
        ModalCheckboxList,
        FilterByDateRange
    }
})
export default class InsuranceAnalyticSowing extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper
) {
    allItemsList: Array<object> = [];
    propertiesData: object | null = null;
    optionsFromResponse: sowingRanchsProperties | null = null 
    visibleModalExportDepuration: boolean = false;
    downloadFormatOptions: Array<object> = [];
    exportDepurationTitle: string = 'Exportar depuración'
    defaultFileNameExportDepuration: string = 'exportar_depuracion_chacras_siembra_' + this.getCurrentTime();
    exportDepurationOptions: object = sowingExportDepurationsOptions;
    requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
    savedQueries: string[] = [];

    updateSavedFilters(value: string[]){
        this.selectedRanchsByUser = [];
        this.savedQueries = value;
    }

    @Watch('savedQueries', { immediate: true, deep: true })
    watchSavedQueries(value){
        this.searchParams.query = value.join(',');
        this.findRanchs();
    }
   

    
    visibilityModalExportDepuration(value) {
        this.visibleModalExportDepuration = value;
    }

    exportDepurationAction(fileName, checkedOptions, formatsSelected){
        this.$_showLoadingDialog('Exportando depuración...');
        let ranchIds = getIdsFromList(this.getRanchsToExport());
        let config:sowingDepurationExport = {
            sowing_ranch_polygon: false, //polígono de chacra
            sown_ranch_polygon: false, //polígono avance de siembra,
            smooth_resowing_ranch_polygon: false, //polígono de resiembra,
            resowing_ranch_polygon: false, //polígono de avance de resiembra
            format: Number(formatsSelected['id']),
            ...(ranchIds.length > 0 ? {
                sowing_ranch_ids: ranchIds.join(',')
            } : {})
        }
        for (let index = 0; index < checkedOptions.length; index++) {
            const optionChecked = checkedOptions[index];
            config[optionChecked] = true;
        }
        let filters = this.searchParams;
        if(filters.companies){
            filters.companies = filters.companies.join(',');
        }
        if(filters.query === ''){
            delete filters['query']
        }
        InsuranceServices.exportSowingRanchsDepuration(
            config,
            this.searchParams
        ).then((res) => {
            this.$_successLoadingDialog({
                response: res,
                alternative_msg: 'Archivo generado con éxito',
                timeout: 12000
            });
        }).catch((error) => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudo generar el archivo'
            });
        })
    }
    
    advancedFilter(items, search, filter){
        return nestedFilter(items, search, filter)
    }

    updatesearchParams(page, itemsPerPage){
        this.searchParams.page = page;
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.query = this.searchRanchList;
        this.findRanchs();
    }

   
    @Watch('$_getInsuranceProperties', { immediate: true, deep: true })
    observableProperties(data) {
        this.assignPropertiesData();
    }

    clickBtnExportDepuration(){
        this.visibilityModalExportDepuration(true);
    }

    downloadRanchs(fileName: string, extensionSelected: string, includePublicNotes: boolean, versionPdfSelected: object | null) {
        this.pendingDownloadRanchs = true;
        let nameOfFile = fileName;

        switch (extensionSelected) {
            case 'PDF':
                this.downloadRanchsToPDF(nameOfFile, includePublicNotes);
                break;
            case 'Excel':
                this.downloadRanchsToExcel(nameOfFile);
                break;
        }
    }
    filtersInsuranceCompaniesSelected: Array<object>[] = [];
    noOptionsFound: string = 'No hay opciones que coincidan con la búsqueda';
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;
    loadingOptionsCompany: boolean = false;
    itemsList: Array<object> = [];
    selectedRanchsByUser: Array<object> = [];
    pendingGeojsonRanchs: boolean = false;
    pendingPDFRanchs: boolean = false;
    pendingExcelRanchs: boolean = false;
    pendingDownloadRanchs: boolean = false;
    seeOnlyResowing: boolean = false;
    visibleModalDownloadRanchs: boolean = false;
    filtersClosedSelected: object | null = null;
    filtersClosedSelectedRv: boolean = false;
    paginationTotalPages: number = 0;
    paginationTotalRows: number = 0;
    farmingType: number = farmingTypesDict.sowing

    

    updateFiltersCloseSelected(value){
        this.filtersClosedSelected = value;
    }
    updateFiltersCloseRv(value){
        this.filtersClosedSelectedRv = value;
    }

    headers: any = [
        {
            text: 'Chacra',
            value: 'name',
            sortable: true
        },
        {
            text: 'Alertas',
            value: 'warnings',
            width: '150px',
            sortable: false
        },
        {
            text: 'Estado del cálculo',
            value: 'has_changes', //has_changes
            align: 'center',
            width: '89px',
            sortable: false
        },
        {
            text: 'Inicio',
            value: 'start_date',
            formatter: (value) => {
                return formatDate(value, true)
            },
            align: 'center',
            width: '140px',
            sortable: true
        },
        {
            text: 'Fin',
            value: 'end_date',
            formatter: (value) => {
                return formatDate(value, true)
            },
            width: '140px',
            align: 'center',
            sortable: true
        },
        {
            text: 'Empresa',
            value: 'company.name',
            sortable: true,
        },
        {
            text: 'Aseguradora',
            value: 'insurance_company.name',
            sortable: true,
        },
        {
            text: '% Avance',
            value: 'progress',
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.humidity)
            },
            sortable: true
        },
        {
            text: 'Area',
            value: 'area',
            unit: unitValues[unitsValuesChoices.area],
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.area)
            },
            sortable: true
        },
        {
            text: 'Area Siembra',
            value: 'sown_area',
            unit: unitValues[unitsValuesChoices.area],
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.area)
            },
            sortable: true
        },
        {
            text: 'Area Resiembra',
            value: 'resown_area',
            unit: unitValues[unitsValuesChoices.area],
            formatter: (value) => {
                return this.parseNumber(value, unitsValuesChoices.area)
            },
            sortable: true
        },
        {
            text: 'Cerrada',
            value: 'finished',
            align: 'center',
            sortable: true,
            formatter: booleanFormatter,
        },
        {
            text: 'Zafra',
            value: 'harvest.farming.name',
            sortable: false
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            width: '100px',
            sortable: false
        }
    ];

    pendingItems: boolean = false;

    pageTitle: string = 'Vista analítica de Siembra';
    summaryData: object[] = [];
    cropTypeOptions: Array<object> = [];
    optionsCompany: Array<object> = [];
    optionsInsuranceCompany: Array<object> = [];
    searchRanchList: string = '';

    defaultName: string = 'chacras_siembra_' + this.getCurrentTime()
    fileName: string = '';
    insuranceCompanies: Array<object> = [];
    companyFarmingPatchData: object = {};
    farmingTypeToDelete: string = '';

    filteredTableItems: Array<object> | null = null;
    searchParams: SowingRanchListFilters = {
        page: 1,
        page_size: 10,
    };
    
    filtersParams: SowingRanchListFilters = {};

    searchAction(params:InsuranceFilters){
        this.selectedRanchsByUser = [];
        let pageSize = this.searchParams.page_size;
        this.searchParams.page = 1;
        this.searchParams = {
            page_size: pageSize,
            ...params
        };
        this.findRanchs();
    }

    updateTableOptions({sortBy, sortDesc, itemsPerPage, page}){
        this.searchParams.page_size = itemsPerPage;
        this.searchParams.page = page;
        if(sortBy.length ==  0){
            delete this.searchParams.sort_by;
            delete this.searchParams.sort_type;
        }else{
            let sortType = sortDesc[0] == true ? sortTypes.desc : sortTypes.asc;
            this.searchParams.sort_by = sortBy;
            this.searchParams.sort_type = sortType;
        }
        this.findRanchs();
        
    }

    getCurrentTime(){
        return getCurrentTimestamp(dateTypes.globalFilterDateFormat)
    }

    

    clickBtnDownloadRanchs() {
        this.visibilityModalDownloadRanchs(true);
    }



    updateSelectedRanchs(ranchs:Array<object>) {
        this.selectedRanchsByUser = ranchs;
    }

    visibilityModalDownloadRanchs(value) {
        this.visibleModalDownloadRanchs = value;
    }

    downloadRanchsToPDF(nameOfFile: string, includePublicNotes: boolean) {
        let filteredRanchs = this.getRanchsToExport();
        let ids = getIdsFromList(filteredRanchs);

        InsuranceServices.getSowingRanchsPdf(ids, nameOfFile, includePublicNotes, this.searchParams)
            .then((res) => {
                this.$_successLoadingDialog({
                    response: res,
                    alternative_msg: 'Archivo generado con éxito',
                    timeout: 12000
                });
                this.pendingDownloadRanchs = false;
            })
            .catch((error) => {
                this.pendingDownloadRanchs = false;
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'Falló la exportación de PDF'
                });
            });
    }

    downloadRanchsToExcel(fileName: string) {
        this.pendingDownloadRanchs = true;
        let filteredRanchs = this.getRanchsToExport();
        let ids = getIdsFromList(filteredRanchs);

        InsuranceServices.getSowingRanchsAsExcel(ids, this.searchParams)
            .then((res) => {
                this.pendingDownloadRanchs = false;
                downloadArrayBuffer(fileName, res);
            })
            .catch((error) => {
                this.pendingDownloadRanchs = false;
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'Falló la exportación a Excel'
                });
            });
        
    }

    getRanchsToExport() {
        return this.selectedRanchsByUser;
    }

    get getAditionalLabel() {
        if(this.selectedRanchsByUser.length > 0){
            return `(${this.selectedRanchsByUser.length} Seleccionadas)`;
        }
        return `<b>(Filtros)</b>`;
    }

    seeRanchDetail(item) {
        let ranchId = item['id'];
        let url = getUrlRanchSowingDetail(ranchId);
        goToUrl(url, true);
    }


    statusFormatter(value) {
        return value ? 'Activa' : 'Inactiva';
    }

    insuranceFarmingFormatter(farmingId) {
        let allInsuranceCompanies = this.$_getInsuranceProperties['insurance_farmings'];
        if (allInsuranceCompanies) {
            let companyIndex = allInsuranceCompanies.findIndex(item => item['id'] === farmingId);
            if (companyIndex !== -1) {
                return allInsuranceCompanies[companyIndex]['name'];
            }
        }
    }


    cropTypeFormatter(cropTypeId) {
        let allCropTypes = this.$_getInsuranceProperties['harvest_type'];
        if (allCropTypes) {
            let cropTypeIndex = allCropTypes.findIndex(item => Number(item['id']) === cropTypeId);
            if (cropTypeIndex !== -1) {
                return allCropTypes[cropTypeIndex]['value'];
            }
        }
    }

    @Watch('isCarrier')
    observableIsCarrier() {
        this.checkIfNeedToHideCalcStatus();
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    mounted() {
        this.$nextTick(() => {
            this.assignPropertiesData();
            this.checkIfNeedToHideCalcStatus();
        });
    }

    checkIfNeedToHideCalcStatus(){
        if(this.isCarrier){
            this.headers = this.headers.filter(item => item['value'] !== 'has_changes');
        }
    }


    assignPropertiesData() {
        this.cropTypeOptions = this.$_getInsuranceProperties['harvest_type'];
        this.setInsuranceCompanies();
        this.setExportFormats(this.$_getInsuranceProperties['geometry_export_formats']);
        this.propertiesData = this.$_getInsuranceProperties;
    }

    setExportFormats(options){
        this.downloadFormatOptions = options;
    }

    findRanchs(){
        this.getRanchList();
    }


    getRanchList(){
        this.requestTokenInstance.cancel();
        this.requestTokenInstance = Axios.CancelToken.source();
        this.searchingItems(true);
        InsuranceServices.getSowingRanchList(
            this.requestTokenInstance, 
            this.searchParams
        )
        .then(res => {
            this.paginationTotalPages = res.totalPages;
            this.paginationTotalRows = res.count;
            this.optionsFromResponse = res.properties;
            this.setTableItems(res.data);
            this.searchingItems(false);
            this.optionsFromResponse = res.properties;
            if(res.summary){
                res.summary.total_ranchs = res.count;
                this.updateSummary(res.summary);
            }
        })
        .catch(err => {
            if(err && err.message == 'Request canceled'){
                this.searchingItems(true);
                return;
            }
            this.paginationTotalPages = 1;
            this.paginationTotalRows = 0;
            this.setTableItems([]);
             this.searchingItems(false);
            if(err && err.response && err.response.data){
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'Ocurrió un error al obtener las chacras'
                });
            }
        }).finally(() => {
            this.searchingItems(false);
        });
    }
 

    formatAlert(alerts: string[]) {
        let msgs: string[] = [];
        for (let index = 0; index < alerts.length; index++) {
            let alert = alerts[index];
            if (alert.indexOf('<br>') == -1) {
                alert += '<br>';
            }
            msgs.push(alert);
        }

        return {
            msgs: msgs
        };
    }

    updateSummary(summary) {
        let area_trabajada = summary.worked_area,
            chacras_totales = summary.total_ranchs,
            area_total = summary.total_area,
            area_total_cerrada = summary.total_closed_area,
            area_total_resiembra = summary.total_resowing_area,
            chacras_cerradas = summary.closed_ranchs,
            chacras_proceso = summary.ranchs_in_progress,
            chacras_con_resiembra = summary.ranchs_with_resowing;

        this.setSummaryData(
            area_total,
            area_trabajada,
            area_total_cerrada,
            area_total_resiembra,
            chacras_totales,
            chacras_cerradas,
            chacras_proceso,
            chacras_con_resiembra,
        );
    }

    searchingItems(value) {
        this.pendingItems = value;
    }

    setTableItems(items) {
        if(items.length > 0){
            items = items.map(function(item){
                return {
                    ...item,
                    harvest: item.sowing,
                    cerrada: booleanFormatter(item['closed']),
                }
            })
        }
        this.itemsList = items;
    }

    parseNumber(value, key) {
         return getValueParsedByType(value, unitsValuesChoices[key]);
    }

    updateInsuranceSearchValue(value) {
        this.selectedRanchsByUser = [];
        this.searchRanchList = value;
        if(isNullOrEmpty(value)){
            delete this.searchParams.query;
        }else{
            this.searchParams.query = value;
        }
        this.searchParams.page = 1
        this.findRanchs();
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });
        return uniqueObject;
    }
    setSummaryData(
        area_total,
        area_trabajada,
        area_total_cerrada,
        area_total_resiembra,
        chacras_totales,
        chacras_cerradas,
        chacras_proceso,
        chacras_con_resiembra
    ) {
        this.summaryData = this.summaryData = [
            {
                text: areaTotal.text,
                value: getValueAndUnit(area_total, unitsValuesChoices.area),
                info:  areaTotal.tooltip
            },
            {
                text: areaTrabajada.text,
                value: getValueAndUnit(area_trabajada, unitsValuesChoices.area),
                info: areaTrabajada.tooltip
            },
            {
                text:  areaTotalCerrada.text,
                value: getValueAndUnit(area_total_cerrada, unitsValuesChoices.area),
                info:  areaTotalCerrada.tooltip
            },
            {
                text: areaTotalResiembra.text,
                value: getValueAndUnit(area_total_resiembra, unitsValuesChoices.area),
                info:  areaTotalResiembra.tooltip
            },
            {
                text: 'Chacras totales',
                value: chacras_totales,
            },
            {
                text: 'Chacras cerradas',
                value: chacras_cerradas
            },
            {
                text: 'Chacras proceso',
                value: chacras_proceso
            },
            {
                text: 'Chacras con resiembra',
                value: chacras_con_resiembra
            }
        ];;
    }

    setInsuranceCompanies() {
        let insuranceCompanies = this.$_getInsuranceProperties['insurance_companies'];
        this.optionsInsuranceCompany = insuranceCompanies;
    }

    updateFilteredItems(filteredItems) {
        this.filteredTableItems = filteredItems;
    }

    backToInsurance() {
        this.$router.push(NAME_ROUTES.INSURANCE.path);
    }
}
